import { render, staticRenderFns } from "./CreateProjectUserStory.vue?vue&type=template&id=75230906&"
import script from "./CreateProjectUserStory.vue?vue&type=script&lang=js&"
export * from "./CreateProjectUserStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
